import { IUserServiceTypeObj, IUserViewObj } from "../../../shared/apiServices/IApiInterfaces";

const ManagerUserMapper = {
  getAttributes: ({ Attributes, Username  }: IUserServiceTypeObj, adminUsers: Set<string>): IUserViewObj => {
    return {
      firstName: Attributes.find((a) => a.Name === 'given_name')?.Value ?? '',
      lastName: Attributes.find((a) => a.Name === 'family_name')?.Value ?? '',
      username:
      Attributes.find((a) => a.Name === 'preferred_username')?.Value ?? '',
      email: Attributes.find((a) => a.Name === 'email')?.Value ?? '',
      site: Attributes.find((a) => a.Name === 'locale')?.Value ?? '',
      admin: adminUsers.has(Username),
      userId: Username,
    };
  }
};

export default ManagerUserMapper;
